import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type {
  CnAutomationDto,
  CnAutomationRefreshResult,
  ListCnAutomationParams,
} from './cn.types'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

/** Public CN automation slice — no auth headers; use standalone route `/cn_automation`. */
export const cnApi = createApi({
  reducerPath: 'cnApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ['CnAutomation'],
  endpoints: (builder) => ({
    listCnAutomation: builder.query<CnAutomationDto[], ListCnAutomationParams>({
      query: ({ terminal, processStatus }) => ({
        url: 'oapi/v1/public/cn-automation',
        method: 'GET',
        params: { terminal, processStatus },
      }),
      providesTags: ['CnAutomation'],
    }),

    patchCnAutomationAppointment: builder.mutation<
      CnAutomationDto,
      { automationId: string; body: { eventDate: string; timeSlot: string } }
    >({
      query: ({ automationId, body }) => ({
        url: `oapi/v1/public/cn-automation/${automationId}/appointment`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CnAutomation'],
    }),

    cancelCnAutomationModification: builder.mutation<CnAutomationDto, { automationId: string }>({
      query: ({ automationId }) => ({
        url: `oapi/v1/public/cn-automation/${automationId}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['CnAutomation'],
    }),

    /** Downloads CN spreadsheets for Brampton, Mississauga, and Malport (today + 4 days). */
    refreshFromCnPortal: builder.mutation<CnAutomationRefreshResult, void>({
      query: () => ({
        url: 'oapi/v1/public/cn-automation/sync-from-portal',
        method: 'POST',
      }),
      invalidatesTags: ['CnAutomation'],
    }),
  }),
})

export const {
  useListCnAutomationQuery,
  usePatchCnAutomationAppointmentMutation,
  useCancelCnAutomationModificationMutation,
  useRefreshFromCnPortalMutation,
} = cnApi
